import { ISideBar } from '@/types/types';

export const links: { [key: string]: Array<ISideBar | { label: string }> } = {
  users: [
    {
      label: 'General',
    },
    {
      link: 'account.dashboard',
      icon: 'space_dashboard',
      text: 'Dashboard',
    },
    {
      link: 'account.groups',
      icon: 'groups',
      text: 'Groups',
    },
    {
      link: 'account.sender.ids',
      icon: 'send_to_mobile',
      text: 'Sender IDs',
    },
    {
      link: 'account.contacts',
      icon: 'contacts',
      text: 'Contacts',
    },
    {
      label: 'Campaigns',
    },
    {
      link: 'account.sms.bulk',
      icon: 'send',
      text: 'Bulk SMS',
    },
    {
      link: 'account.sms.personalize',
      icon: 'tune',
      text: 'Personalize SMS',
      isNew: false,
    },
    {
      label: 'Automations',
    },
    {
      link: 'account.events.list',
      icon: 'event_note',
      text: 'Events',
      isNew: false,
    },
    /* Tabled until the pages exist. Restore these three (and the USSD label)
       by uncommenting; the `soon` flag renders them as dimmed, non-clickable
       rows, so they can go back in before the routes are built.

    { label: 'USSD' },
    {
      link: 'account.ussd.subscriptions',
      icon: 'dialpad',
      text: 'Subscriptions',
      soon: true,
    },
    {
      link: 'account.ussd.service-codes',
      icon: 'pin',
      text: 'Service Codes',
      soon: true,
    },
    */
    { label: 'Billing' },
    {
      link: 'account.invoices',
      icon: 'receipt',
      text: 'Invoices',
      isNew: true,
      hideForSubAccount: true,
    },
    {
      link: 'account.payments.history',
      icon: 'account_balance_wallet',
      text: 'Payments',
      isNew: false,
      hideForSubAccount: true,
    },
    { label: 'Insights' },
    {
      link: 'account.campaigns',
      icon: 'campaign',
      text: 'Campaigns',
      isNew: true,
    },
    {
      link: 'account.messages',
      icon: 'sms',
      text: 'Sent Messages',
      isNew: false,
    },
    {
      link: 'account.top-up.history',
      icon: 'receipt_long',
      text: 'Top Up History',
      isNew: false,
    },
    {
      link: 'account.downloads',
      icon: 'download',
      text: 'Downloads',
      isNew: false,
    },
    {
      label: 'Settings',
    },
    // {
    //   link: 'account.profile',
    //   icon: 'face',
    //   text: 'My Profile',
    //   isNew: false,
    // },
    {
      link: 'account.api.keys',
      icon: 'vpn_key',
      text: 'API Keys',
    },
    {
      link: 'account.sub-accounts',
      icon: 'manage_accounts',
      text: 'Sub Accounts',
      isNew: false,
      isBusiness: true,
      isReseller: true,
    },
    /* Feedback and Bug Report now live under the Help Center tab of the
       profile dropdown in the toolbar */
  ],
  doctor: [
    {
      label: 'General',
    },
    {
      link: 'accounts.admin.dashboard',
      icon: 'people',
      text: 'Patients',
    },
  ],
};
